import { toLower } from 'lodash';
import { push } from 'connected-react-router';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUserRequest } from '../../../../store/modules/users/actions';
import { SimpleConfirmationDialog } from '../../../../components';
import useStyles from '../styles';
import { selectCurrentUser } from '../../../../store/modules/users/selectors';
import { getPaymentMethodRequest } from '../../../../store/modules/billing/actions';

type Props = {
  success: boolean;
  open: boolean;
  errorMessage: string;
  setOpen: (bool: boolean) => void;
};

const CheckoutFormModal = ({
  success,
  open,
  errorMessage,
  setOpen,
}: Props) => {
  const { data: user } = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const classes = useStyles();

  const onSuccessHandler = useCallback(() => {
    dispatch(getCurrentUserRequest());
    if (user) {
      dispatch(getPaymentMethodRequest(user.id));
    }
    dispatch(push('/dashboard/home'));
  }, [dispatch, user]);

  return (
    <SimpleConfirmationDialog
      open={open}
      title={success ? 'Payment successful' : 'Payment failed'}
      message={success
        ? 'A confirmation email will be sent to you soon'
        : `The payment failed because  ${toLower(errorMessage)}`}
      buttonText={success ? 'Ok' : 'Try again'}
      closeHandler={success
        ? () => onSuccessHandler()
        : () => setOpen(false)}
      className={classes.dialog}
    />
  );
};

export default CheckoutFormModal;
